'use client';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { toast } from 'react-toastify';
import React from 'react';
import {
	FiAlertCircle,
	FiAlertTriangle,
	FiCheckCircle,
	FiInfo,
} from 'react-icons/fi';
import { notification, theme } from 'antd';


const confirm = async (
	title: string,
	text: string,
	themeTokens: any
): Promise<boolean> => {
	const {
		token: { colorPrimary, colorError, colorBgContainer, colorText },
	} = themeTokens;

	const result: SweetAlertResult = await Swal.fire({
		title: title,
		text: text,
		icon: 'question',
		showCancelButton: true,
		confirmButtonColor: colorPrimary,
		cancelButtonColor: colorError,
		confirmButtonText: 'Aceptar',
		cancelButtonText: 'Cancelar',
		focusConfirm: false,
		color: colorText,
		background: colorBgContainer,
	});

	return result.isConfirmed;
};

const warning = (title: string, text: string, themeTokens?: any) => {
	return Swal.fire({
		title: title,
		text: text,
		icon: 'warning',
		background: themeTokens.colorBgContainer,
		confirmButtonText: 'Aceptar',
	});
};

const modalSuccess = (title: string, text: string, themeTokens?: any) => {
	return Swal.fire({
		title: title,
		text: text,
		icon: 'success',
		// background: themeTokens.colorBgContainer,
		confirmButtonText: 'Aceptar',
	});
};

const modalError = (title: string, text: any, themeTokens?: any) => {
	return Swal.fire({
		title: title,
		text: text.response.data.errores[0].detalle,
		icon: 'error',
		// background: themeTokens.colorBgContainer,
		confirmButtonText: 'Aceptar',
	});
};

const toastSuccess = (text: string) => {
	toast.success(text, {
		position: 'bottom-right',
		autoClose: 10000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	});
};

const renderAlert = (type: string, message: string) => {
	let icon = <FiInfo />;
	let title = '';

	switch (type) {
		case 'success':
			icon = <FiCheckCircle />;
			title = 'Éxito';
			break;
		case 'warning':
			icon = <FiAlertTriangle />;
			title = 'Advertencia';
			break;
		case 'error':
			icon = <FiAlertCircle />;
			title = 'Error';
			break;
		case 'info':
			icon = <FiInfo />;
			title = 'Información';
			break;
		default:
			break;
	}

	return (
		<div className={`alert ${type}`}>
			<div className="title">
				<div className="icon">{icon}</div>
				{title}
			</div>
			<div className="description">{message}</div>
		</div>
	);
};

const toastError = (text: string) => {
	toast.error(text, {
		position: 'bottom-right',
		autoClose: 10000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	});
};

const toastWarning = (text: string) => {
	toast.warn(text, {
    position: "top-right",
    autoClose: 500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
	});
};

const toastInfo = (text: string) => {
	toast.info(text, {
		position: 'bottom-right',
		autoClose: 10000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	});
};

const notificactionSuccess = (text: string) => {
  notification.success({
    message: 'Éxito',
    description: text,
    placement: 'topRight',
  });
}

const notificactionError = (text: string) => {
  notification.error({
    message: 'Error',
    description: text,
    placement: 'topRight',
  });
}

const notificactionWarning = (text: string) => {
  notification.warning({
    message: 'Advertencia',
    description: text,
    placement: 'topRight',
  });
}

const notificactionInfo = (text: string) => {
  notification.info({
    message: 'Información',
    description: text,
    placement: 'topRight',
  });
}



export {
	confirm,
	warning,
	modalSuccess,
	modalError,
	renderAlert,
  notificactionSuccess,
  notificactionError,
  notificactionWarning,
  notificactionInfo,
};
